"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = void 0;
function round(x, precision) {
    if (precision) {
        var factor = Math.pow(10, precision);
        return Math.round(x * factor) / factor;
    }
    return Math.round(x);
}
exports.round = round;
